export default __webpack_public_path__ + "static/media/eye-hide-color.18abd75b.svg";